import React from "react";

export const QuotesLogo = ({
  width = "30",
  height = "30",
  fill = "none",
  color = "white",
}) => (
  <svg
    width={width}
    height={height}
    fill={fill}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    style={{ marginTop: "5px" }}
  >
    <path
      d="M3.33331 15.538V6.71172C3.33331 4.33338 3.33331 3.14421 4.06555 2.40536C4.79778 1.6665 5.97629 1.6665 8.33331 1.6665H11.6666C14.0236 1.6665 15.2021 1.6665 15.9344 2.40536C16.6666 3.14421 16.6666 4.33338 16.6666 6.71172V15.538C16.6666 16.7978 16.6666 17.4276 16.2816 17.6755C15.6526 18.0808 14.6801 17.231 14.1909 16.9226C13.7867 16.6677 13.5847 16.5403 13.3604 16.5329C13.1181 16.5249 12.9124 16.6472 12.4757 16.9226L10.8833 17.9268C10.4537 18.1977 10.239 18.3332 9.99998 18.3332C9.76098 18.3332 9.54623 18.1977 9.11665 17.9268L7.52425 16.9226C7.1201 16.6677 6.91803 16.5403 6.69375 16.5329C6.45141 16.5249 6.24575 16.6472 5.80904 16.9226C5.31994 17.231 4.34737 18.0808 3.71827 17.6755C3.33331 17.4276 3.33331 16.7978 3.33331 15.538Z"
      stroke={color}
      stroke-opacity="0.6"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.16663 9.1665H6.66663"
      stroke={color}
      stroke-opacity="0.6"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.6666 5.8335H6.66663"
      stroke={color}
      stroke-opacity="0.6"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
